import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const stores = crudlModuleGenerator('stores');

export const INITIAL_STORES_FILTERS = {
  CRUDL_append: false,

  q: '',
  sort: 'name_asc',
  per_page: 20,
  publicable: null,
};

export default {
  ...stores,
  state: {
    ...stores.state,
    list: {
      ...stores.state.list,
      filters: {
        ...INITIAL_STORES_FILTERS,
      },
    },
  },
};
